<template>
	<div>
		<router-view/>
		<counsel-modal/>
		<Footer />
	</div>
</template>

<script>
import Footer from "@/layouts/Footer";
import CounselModal from "@/components/CounselModal";
export default {
	components: {CounselModal, Footer}
}
</script>